import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useWpbModel } from "../wpbModel";

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useWpbModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "采购合同号",
            fieldName: "purchaseCode",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "预警状态",
            fieldName: "warningType",
            options: getSelectedDictOne(DictCodeEnmu.WARNING)
        },
        // {
        //     type: SearchTypeEnum.Datepicker,
        //     placeholder: "付款日期",
        //     fieldName: "settlementTime",
        // },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["付款起始日期", "付款结束日期"],
            // showTime: true,
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]

    return (
        <YhPageHeader
            title="应付账款预警列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}